import { Activity, type LucideIcon, Store, Tag } from "lucide-react";

export type Stage = "presale" | "opening" | "active";

// The franchise growth pipeline: pre-sale → opening → active.
export const PIPELINE: {
  id: Stage;
  label: string;
  sub: string;
  count: number;
  icon: LucideIcon;
}[] = [
  { id: "presale", label: "Pre-sale", sub: "Selling before opening", count: 5, icon: Tag },
  { id: "opening", label: "Opening soon", sub: "Launching within 30 days", count: 3, icon: Store },
  { id: "active", label: "Active", sub: "Open & operating", count: 16, icon: Activity },
];

export type LocationStatus = "healthy" | "ontrack" | "prepping" | "risk";

export type LocationRow = {
  id: string;
  name: string;
  city: string;
  stage: Stage;
  metric: string;
  trend: number;
  status: LocationStatus;
  risk?: boolean;
};

// One representative slice of the network. The last row is the slipping
// location Helios surfaces for corporate.
export const LOCATIONS: LocationRow[] = [
  {
    id: "denver",
    name: "Denver LoHi",
    city: "Denver, CO",
    stage: "active",
    metric: "1,240 members",
    trend: 6,
    status: "healthy",
  },
  {
    id: "seattle",
    name: "Seattle Cap Hill",
    city: "Seattle, WA",
    stage: "active",
    metric: "1,090 members",
    trend: 4,
    status: "healthy",
  },
  {
    id: "brooklyn",
    name: "Brooklyn Heights",
    city: "Brooklyn, NY",
    stage: "presale",
    metric: "412 pre-sales",
    trend: 22,
    status: "ontrack",
  },
  {
    id: "austin",
    name: "Austin Domain",
    city: "Austin, TX",
    stage: "presale",
    metric: "286 pre-sales",
    trend: 15,
    status: "ontrack",
  },
  {
    id: "miami",
    name: "Miami Brickell",
    city: "Miami, FL",
    stage: "opening",
    metric: "Opens in 9 days",
    trend: 0,
    status: "prepping",
  },
  {
    id: "phoenix",
    name: "Phoenix Camelback",
    city: "Phoenix, AZ",
    stage: "active",
    metric: "892 members",
    trend: -18,
    status: "risk",
    risk: true,
  },
];

// The insight Helios surfaces for corporate to act on — visibility, not a
// message to the customer.
export const INSIGHT = {
  location: "Phoenix Camelback",
  headline: "Visits down 18% over 14 days",
  detail: "Driven by 27 lapsed 4×/month members and 3 canceled corporate group bookings.",
  signals: [
    { label: "Visits", value: "↓ 18%" },
    { label: "Lapsed members", value: "27" },
    { label: "Cancellations", value: "3" },
  ],
} as const;
